/**
 * Created by Dmitry on 26.02.14.
 */
callpy_global.CStorage = function()
{
    this.module_name = "CStorage ";
    //defines module priority to log?
    this.module_log_rang = 100;

    var _this = this;

    //активна ли вкладка
    this.activeTab = true;
    if (document.mozHidden == true || document.msHidden == true || document.webkitHidden==true || document.hidden ==true) this.activeTab = false;

    this.storage = Object();

    this.first_time_focus = true;

    this.restoreTimer = null;

    //TODO: определяем IE
    this.restoreInIE = /*@cc_on!@*/false || !!document.documentMode;

    this.handleFlag = true;
    this.handleCallFlag = true;
    this.handleDataFlag = true;

    this.focusTimer = null;

    this.focusedWindow = false; //сфокусировано ли основное окно (для работы с onblur и onfocus из фрейма при разговоре)

    this.pageViews = 1; //количество просмотров страниц в ТЕКУЩЕЙ сессии

    this.init = function()
    {

        if (localStorage.getItem("callpy_data")!=null && callpy_from_ls){
            _this.restoreData();
            //счетчик посещений/просмотров
            _this.pageViews = localStorage.getItem("callpy_views");
            if (_this.pageViews){
                if (m_callpy.client_data.peer_key) _this.pageViews++; //счетчик увеличиваем только в случае наличия консультанта
            }else{
                _this.pageViews = 1;
            }
            localStorage.setItem("callpy_views", _this.pageViews);
            //FIXED: при отсутствии ответа от Realplexor в течение 30 секунд (а такое может быть и при нормальном функционировании системы, если клиент постоянно обновляет страницы)
            //не происходило обновление значения lastSave в LocalStorage, по которому в коде вставки определяется, восстанавливать ли из LocalStorage чат.
            //Поэтому, если при загрузке страницы происходит восстановление из LS, можно обновить lastSave, отсчет производится от подключения к каналу
            _this.storage.lastSave = new Date().getTime();
            localStorage.setItem("callpy_data", JSON.stringify(m_callpy.m_storage.storage));
        }
        else{
            localStorage.removeItem("callpy_data"); //FIXED: из-за обфускации названия свойств объекта в callpy_data могут не совпадать с текущими; данные нужны на время сессии, поэтому можно удалить
            localStorage.setItem("callpy_views", _this.pageViews);
        }
        //TODO: автоприветствие по числу страниц - перенесено в m_chat_init, после вызова gui init
        //m_callpy.m_activity.automessage_pageCheck();

        //Запоминаем время последнего полученного сообщения от Rlplx. Если первая загрузка, то считаем его равным текущему времени
        if (!callpy_from_ls){
            localStorage.setItem("callpy_lastRpx", new Date().getTime());
            //UPDATED: сюда подставляется "код вставки" (бывший) как одна строка. Впоследствии, при вызове this.saveData() он запишется в LS
            _this.storage.insertcode = '_CALLPY_INSERT_CODE';
        }

        window.addEventListener("unload", function(){
            _this.saveData();

            //TODO: подумать, что делать при закрытии активной вкладки, если есть еще одна
            //m_callpy.m_bridge.to_fms({action: "update_status", status: "0" + (($jcallpy('#callpy_lableCont').attr('data-status') == "off" && m_callpy.client_data.peer_key)?"1":"0") + (m_callpy.m_chat.history.length?"1":"0"), peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0), domain: m_callpy.client_data.site});

            //TODO: NEW CHAT: изменить проверку
            //if ($jcallpy.callpy_call('status').status == "outcoming" || $jcallpy.callpy_call('status').status == "access_equip"){
            if (m_callpy.m_chat.call_status == "calling_to_manager"){ //влияло ли второе условие на момент заглушки в момент входящего вызова?
                //скорее всего, влияло негативным образом: прерывать дозвон при закрытии владки необходимо только в случае звонка клиента, а старому условию удовлетворяет и заглушка в момент входящего
                //закрыли вкладку со звонком в момент загрузки или после загруженной флешки

                localStorage.removeItem("callpy_state");
                localStorage.removeItem("callpy_call_flag");
                //менеджеру сообщение о прекращении звонка
                m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("end_dialup"));
                $jcallpy.callpy_status('set', 'dial_off');
            }
            //TODO: NEW CHAT: изменить проверку
            //else if ($jcallpy.callpy_call('status').status == "call"){
            else if (m_callpy.m_chat.call_status == "call"){
                //если при этом шло удаленное управление, или был запрос о удаленном управлении, сообщаем менеджеру о завершении
                //менеджеру сообщение о прекращении звонка
                m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("end_call"));
                //$jcallpy.callpy_call('end');
                $jcallpy.callpy_status('set', 'call_off');
                localStorage.removeItem("callpy_state");
                localStorage.removeItem("callpy_call_flag");
            }
        });

        window.onbeforeunload = function (){
            //TODO: NEW CHAT: изменить проверку
            //if ($jcallpy.callpy_call('status').status == "outcoming" || $jcallpy.callpy_call('status').status == "call") return "На этой вкладке идет звонок. Если вы закроете ее, звонок прервется. Продолжить?";
            if (m_callpy.m_chat.call_status == "calling_to_manager" || m_callpy.m_chat.call_status == "call") return _("На этой вкладке идет звонок. Если вы закроете её, звонок прервется. Продолжить?");
        }

        if (window.addEventListener) {
            window.addEventListener("storage", handle_storage, false);
        } else {
            window.attachEvent("onstorage", handle_storage);
        };

        //функция слежения за Local Storage для работы с вкладками
        function handle_storage(e) {
            if (!e) { e = window.event; }

            if (e.key == "callpy_html"){
                _this.restoreInIE = false;
                _this.restoreHtml();
            }

            if (_this.restoreInIE && e.key == "html_save"){
                        clearTimeout(_this.restoreTimer);
                        _this.restoreTimer = setTimeout(function() {
                        if (_this.handleFlag) _this.restoreHtml(); else _this.handleFlag = true;
                        }, 350);

            }

            //изменилось состояние callpy (чат-запрос УУ-УУ-звонок)

            //обрабатываем изменение состояния удаленного управления
            if (e.key == "callpy_control_flag"){
                if (!e.newValue){
                    if (e.oldValue == "1"){
                        //GUI: вызвать функцию, которая удалит запрос на удаленное управление

                        //$jcallpy('#callpy_request_remote_wrapper').remove();
                        //$jcallpy('#callpy_setting_wrap_overlay').remove();

                        //FIXED: нет необходимости обрабатывать на других вкладках, т.к. синхронизуется через callpy_html
                        //$jcallpy.callpy_status('set', 'remote_control_off');

                        //$jcallpy('#callpy_remote_connected_wrap').remove();
                    }else{
                        //GUI: удалить кнопку "отмена" при удаленном управлении
                        //$jcallpy('#callpy_remote_connected_wrap').remove();

                        //FIXED: нет необходимости обрабатывать на других вкладках, т.к. синхронизуется через callpy_html
                        //$jcallpy.call_status('set', 'remote_control_end');

                    }
                }else if (e.newValue == "2"){

                    //GUI: показать кнопку "отмена" (ВНЕ блока callpy) - см. cglobal.php

                    //$jcallpy(document.body).append(m_callpy.m_gui_chat.stop_remote_html());
                    //$jcallpy('#callpy_request_remote_wrapper').remove();
                    //$jcallpy('#callpy_setting_wrap_overlay').remove();

                    //FIXED: нет необходимости обрабатывать на других вкладках, т.к. синхронизуется через callpy_html
                    //$jcallpy.callpy_status('set', 'remote_control_start');

                    //обработчик на кнопку "отменить"
                    /*
                    $jcallpy("#drop_remote_request").on("click", function () {
                        m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("remote_control_answer", {0: "stop"}));
                        localStorage.removeItem("callpy_control_flag");
                        //GUI: удалить кнопку "отмена" (та же ф-я, что и выше)
                        $jcallpy('#callpy_remote_connected_wrap').remove();
                    });
                    */
                }
            }

            if (e.key == "callpy_clientSyncData"){
                if (_this.restoreInIE && !_this.handleDataFlag){
                    _this.handleDataFlag = true;
                    return;
                }
                _this.syncData();
            }

            //обрабатываем изменение состояния звонка
            if (e.key == "callpy_call_flag"){

                if (_this.restoreInIE && !_this.handleCallFlag){
                    _this.handleCallFlag = true;
                    return; //не обрабатываем изменения флага, вызванные вкладкой, в которой они произошли
                }

                if (!e.newValue){ //восстанавливаем чат после звонка или дозвона

                    if (e.oldValue == "3" || e.oldValue == "2"){ //завершение звонка теперь обрабатывается через LS
                        //TODO: NEW CHAT: изменить проверку
                        //if ($jcallpy.callpy_call('status').status == "call" || $jcallpy.callpy_call('status').status == "outcoming"){
                        if (m_callpy.m_chat.call_status == "call" || m_callpy.m_chat.call_status == "calling_to_manager"){
                            if (m_callpy.m_flash.call_type=="webrtc"){
                                m_callpy.m_chat.end_call_webrtc();

                                //if (e.oldValue == "3") $jcallpy.callpy_call('end'); //3 - состоявшийся звонок
                                //else $jcallpy.callpy_call('out_cancel','Вы отменили звонок'); //2 - исходящий дозвон
                                if (e.oldValue == "3") $jcallpy.callpy_status('set', 'call_off'); //3 - состоявшийся звонок
                                else $jcallpy.callpy_status('set','dial_off'); //2 - исходящий дозвон
                                $jcallpy.callpy_call('_removeIframe');
                            }
                            else {
                                m_callpy.m_flash.end_flash();
                                //if (e.oldValue == "3") $jcallpy.callpy_call('end'); //3 - состоявшийся звонок
                                //else $jcallpy.callpy_call('out_cancel','Вы отменили звонок'); //2 - исходящий дозвон
                                if (e.oldValue == "3") $jcallpy.callpy_status('set', 'call_off'); //3 - состоявшийся звонок
                                else $jcallpy.callpy_status('set','dial_off'); //2 - исходящий дозвон
                                $jcallpy.callpy_call('_removeIframe');
                            }
                        }else{
                            //m_callpy.m_storage.restoreHtml(true);
                            if (e.oldValue == "3") $jcallpy.callpy_status('set', 'call_off'); //3 - состоявшийся звонок
                            else $jcallpy.callpy_status('set','dial_off'); //2 - исходящий дозвон
                            //FIXED: при входящем звонке на других вкладках будет значение call_status == "incoming", восстановим
                            m_callpy.m_chat.call_status = "no_call";
                        }
                    }else if (e.oldValue == "1"){ //произошла отмена входящего звонка
                        //$jcallpy.callpy_call('status').status = false;
                        //$jcallpy.callpy_call('incoming_cancel_self');


                        //$jcallpy.callpy_status('set', 'incoming_call_off');

                        //FIXED: при входящем звонке на всех вкладках будет значение call_status == "incoming", восстановим
                        m_callpy.m_chat.call_status = "no_call";
                    }

                }else if (e.newValue == "3" || e.newValue == "2"){
                    //TODO: NEW CHAT: изменить проверку
                    //if ($jcallpy.callpy_call('status').status != "access_equip" && $jcallpy.callpy_call('status').status != "call" && $jcallpy.callpy_call('status').status != "outcoming") { //TODO: ПОПРАВИТЬ! потока не будет в момент вызова функции (смены флага)
                    if (m_callpy.m_chat.call_status == "no_call" || m_callpy.m_chat.call_status == "incoming") {
                        //TODO: FLAT: изменить получение HTML-кода со страницы
                        //$jcallpy("#callpy").html(localStorage.getItem("callpy_html_cl"));

                        if (e.newValue == "3"){
                            //$jcallpy('#callpy_manager_call_blocker, #callpy_manager_incoming_block').remove();


                            //FIXED: поскольку на вкладке, где принимаем звонок, происходит запись в LS, нет смысла отдельно обрабатывать для других вкладок, состояние синхронизируется автоматически
                            //$jcallpy.callpy_status('set', 'call_on');


                            //TODO: NEW CHAT: изменить присвоение
                            //$jcallpy.callpy_call('status').status = false;
                            //FIXED:
                            m_callpy.m_chat.call_status = "no_call";

                            /*
                            $jcallpy('#callpy_stop_call').click(function() {
                                m_callpy.m_chat.end_call_from_self();
                            });
                            */
                        }else{
                            //FIXED: поскольку на вкладке, где принимаем звонок, происходит запись в LS, нет смысла отдельно обрабатывать для других вкладок, состояние синхронизируется автоматически
                            //$jcallpy.callpy_status('set', 'dial_on');

                            /*
                            $jcallpy('#callpy_stop_call').click(function() {
                                m_callpy.m_chat.end_dialup_from_self();
                            });
                            */
                        }

                        /*
                        $jcallpy('#callpy_show_call').click(function() {
                            localStorage.setItem("callTab", "1");
                        });
                        */
                    }
                }
            }

            //сработало событие на вкладку со звонком
            if (e.key == 'callTab' && !e.oldValue){
                //TODO: NEW CHAT: изменить проверку
                //if ($jcallpy.callpy_call('status').status){
                if (m_callpy.m_chat.call_status == "calling_to_maanger" || m_callpy.m_chat.call_status == "call"){
                    localStorage.removeItem("callTab");
                    alert(_("Разговор идет на этой вкладке"));
                }
            }

            if (e.key == 'callpy_activity'){
                m_callpy.m_activity.activity = e.newValue;
            }

            if (e.key == 'callpy_views'){
                _this.pageViews = parseInt(e.newValue);
            }

        }


        //при инициализации, если вкладка загружается скрыто, то при первом же фокусе необходимо отправлять сообщение
        //if (document.mozHidden == true || document.msHidden == true || document.webkitHidden==true || document.hidden ==true) m_callpy.first_time_tab = true;

        window.addEventListener('focus', _this.onfocus_handler);
        window.addEventListener('blur', _this.onblur_handler);

        //window.onfocus = _this.onfocus_handler;
        //window.onblur = _this.onblur_handler;

    };

    this.onfocus_handler = function (data)
    {
        if (m_callpy.realplexor && m_callpy.realplexor._realplexor && m_callpy.realplexor._realplexor._prevReqTime && (new Date().getTime() - m_callpy.realplexor._realplexor._prevReqTime)>30000) m_callpy.realplexor._realplexor._loopFunc();

        //TODO: подумать, как избавиться от двойной отправки url (при фокусировании вкладки + при загрузке страницы со стороны сервера)
        _this.activeTab = true;
        m_callpy?.m_chat?.setMessagesRead();
        if (!data["focusFrame"])_this.focusedWindow = true; //если задано data["focusFrame"] - значит, функция вызывается из фрейма (его сфокусировали)
                                                            //а эта переменная определяет не активность вкладки клиента в целом, а именно основного окна
        //m_callpy.m_activity.add_activity(5);
        var tmp = new Date().getTime();
        if (_this.focusTimer) clearTimeout(_this.focusTimer);
        _this.focusTimer = setTimeout(function() {
            m_callpy.m_logger.log("Вызов update_status при onfocus");
            //Запись данных о посещении страницы осуществляется в обработке этого запроса
            //m_callpy.m_bridge.to_fms({action: "update_status", status: "1" + (($jcallpy.callpy_status('api').visible&&m_callpy.client_data.peer_key)?"1":"0") + "2", peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0), domain: m_callpy.client_data.site, referer: encodeURIComponent(window.location.href), width: $jcallpy(window).width(), title: document.title});
        }, 500);
        //необходимо отправить менеджеру сообщение go_url, если это не первая загрузка страницы (при первом сервером отправляется go_url)
            if (m_callpy.client_data.activePage == 1){

                //FIXED: баг с фокусом вкладок на 2 мониторах

               setTimeout(function(){
                   if (_this.activeTab){
                       //TODO: NEW CHAT: изменить проверку
                       //if ($jcallpy.callpy_call('status').status != "call")m_callpy.m_bridge.to_peer({action: "go_url", url: window.location.href, width: $jcallpy(document).width(), height: $jcallpy(document).height(), scroll: m_callpy.m_control.get_top_scroll(), elements: {selects: $jcallpy.callpy_select(), pointers: $jcallpy.callpy_pointer()}, focusTime: tmp, inputs: m_callpy.m_control.getInputs(), title: document.title});
                       var scroll = (m_callpy.m_chat.call_status != "call"?m_callpy.m_control.get_top_scroll():(document.getElementById('callpy_iframeid').contentWindow.m_callpy?document.getElementById('callpy_iframeid').contentWindow.m_callpy.m_control.get_top_scroll():0));
                       //В случае, если сайт заблокирован, не передаем скроллы и клики
                       if (m_callpy.client_data.type == 1 && m_callpy.client_data.site_info.blocked != 0) scroll = 0;

                    //    if (m_callpy.m_chat.call_status != "call")m_callpy.m_bridge.to_peer({action: "go_url", url: window.location.href, width: $jcallpy(document).width(), height: $jcallpy(document).height(), scroll: scroll, elements: {selects: $jcallpy.callpy_select(), pointers: $jcallpy.callpy_pointer()}, focusTime: tmp, inputs: m_callpy.m_control.getInputs(), title: document.title});
                    //    else m_callpy.m_bridge.to_peer({action: "go_url", url: document.getElementById("callpy_iframeid").contentWindow.location.href, width: $jcallpy(document).width(), height: $jcallpy(document).height(), scroll: scroll, elements: {selects: document.getElementById('callpy_iframeid').contentWindow.m_callpy?document.getElementById('callpy_iframeid').contentWindow.$jcallpy.callpy_select():[], pointers: document.getElementById('callpy_iframeid').contentWindow.m_callpy?document.getElementById('callpy_iframeid').contentWindow.$jcallpy.callpy_pointer():[]}, focusTime: tmp, inputs: document.getElementById('callpy_iframeid').contentWindow.m_callpy?document.getElementById('callpy_iframeid').contentWindow.m_callpy.m_control.getInputs():{inputs: [], textareas: [], selects: []}, title: document.getElementById('callpy_iframeid').contentWindow.document.title});
                   }
               }, 50);
            }

        if (!_this.first_time_focus){ //если вкладка фокусируется не впервые (в первый раз при загрузке и так устанавливается необходимое состояние)

        }else{
            _this.first_time_focus = false;
        }
        m_callpy.m_autos.checkAllConditions();
    }

    this.onblur_handler = function ()
    {

        _this.focusedWindow = false;
        //условие нужно, т.к. если открываем страницу в новой (несфокусированной) вкладке, то в ней срабатывает событие blur
        if (_this.activeTab){
            _this.saveData();
            _this.activeTab = false;

            //если у менеджера активно окно этого пользователя, сообщаем менеджеру, что клиент ушел с вкладки
            //TODO: вместо tab_visibility менеджер теперь может следить по изменению статуса (есть инфа по всем его клиентам), и показывать заглушку, если неактивным стал клиент, который выбран
            //if (m_callpy.client_data.activePage == 1){
            //    m_callpy.m_bridge.to_peer({action: "tab_visibility", isVisible: 0});
            //}

            if (_this.focusTimer) clearTimeout(_this.focusTimer);
            m_callpy.m_logger.log("Вызов update_status при onblur");
            console.log('$jcallpy.callpy_status', $jcallpy.callpy_status('api'))
            m_callpy.m_bridge.to_fms({action: "update_status", status: "0" + (($jcallpy.callpy_status('api')?.visible&&m_callpy.client_data.peer_key)?"1":"0") + "2", peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0), domain: m_callpy.client_data.site});

        }
    }

    this.restoreHtml = function(force)
    {
        //если сработало событие изменения LS во время исходящего звонка, ничего восстанавливать не надо - на основной вкладке перетащили чат, а на всех остальных - заглушки
        var flag = localStorage.getItem("callpy_call_flag");

        //if ((flag != "2" && flag != "3")||force){
        var hasVideo = $jcallpy('#callpy_wrapper').hasClass('callpy_status_video');
        if ((1)||force){
            var tmp = localStorage.getItem("callpy_html");
            if (tmp[0]!=" "){
                return;
            }else{
                tmp = tmp.substr(1);
            }
            var callpy_wrapper = document.querySelector('#callpy_wrapper');
            //TODO: FLAT: изменить получение HTML-кода
            if (callpy_wrapper.outerHTML != tmp) {

                document.querySelector('#callpy').innerHTML = tmp;

                //TODO: FLAT
                if (document.getElementById('callpy_chat_scroller')) document.getElementById('callpy_chat_scroller').scrollTop = localStorage.getItem("callpy_userId");
                //document.getElementById('callpy_chat_input_box').value = localStorage.getItem("callpy_text");
                //восстанавливаем обработчики событий

                if (!window.callpy_from_ls) window.callpy_from_ls = true;
                //TODO: FLAT: название блока callpy
                /*m_callpy.m_gui_chat.init({
                    container : $jcallpy('#callpy'),
                    c_change: m_callpy.m_user.change_manager,
                    video: (m_callpy.client_data.site_info.video_chat == 1),//есть ли кнопка видео инфа изнастроек
                    audio: (m_callpy.client_data.site_info.audio_chat == 1),
                    color: m_callpy.client_data.site_info.lbl_color
                });*/

                $jcallpy.callpy_init();

                //навешиваем обработчик на поле ввода чата
                $jcallpy("#callpy_chat_input_box").on('input', function (){
                    m_callpy.m_control.send_textarea_change({id: $jcallpy(this).attr("id"), "name" : $jcallpy(this).attr("name")}, $jcallpy(this).val());
                });

                //в случае звонка - воспроизводим медиапоток
                if (m_callpy.m_chat.call_status=="call"){
                    document.getElementById("callpy_client_video").src = URL.createObjectURL(m_callpy.m_flash.pc.getRemoteStreams()[0]);
                    document.getElementById("callpy_client_video_self").src = URL.createObjectURL(m_callpy.m_flash.pc.getLocalStreams()[0]);
                    //если до восстановления из LS в вкладке был видеозвонок
                    if (hasVideo){
                        $jcallpy('#callpy_wrapper').addClass('callpy_status_video');
                    }
                }
            }


        }
    }

    //записываем данные
    this.saveData = function()
    {
        //FIXED: не записываем в случае отсутствия ответа от Realplexor в течение >=30 сек (чтобы при обновлении страницы гарантированно не восстанавливать все из LS)
        if (new Date().getTime() - localStorage.getItem("callpy_lastRpx") < 30000) _this.storage.lastSave = new Date().getTime();
        //html-код

        _this.storage.m_callpy_site = m_callpy_site;
        _this.storage.callpy_global = Object();
        //_this.storage.callpy_global.callpy = callpy_global.callpy;
        _this.storage.callpy_global.php_server = callpy_global.php_server;
        _this.storage.callpy_global.callpy_domain = callpy_global.callpy_domain;
        _this.storage.m_callpy = Object();
        _this.storage.m_callpy.managers_list = m_callpy.managers_list;
        _this.storage.m_callpy.users_list = m_callpy.users_list;
        _this.storage.m_callpy.client_data = m_callpy.client_data;
        _this.storage.m_callpy.m_chat = Object();
        _this.storage.m_callpy.m_chat.history = m_callpy?.m_chat?.history;
        _this.storage.m_callpy.m_chat.history_dialogs = m_callpy.m_chat?.history_dialogs;
        /*
        _this.storage.m_callpy.m_chat.mainContainer = $jcallpy('#callpy_main_container').data();
        _this.storage.m_callpy.m_chat.left = $jcallpy('#callpy_main_container').css('left');
        _this.storage.m_callpy.m_chat.top = $jcallpy('#callpy_main_container').css('top');
        */
        _this.storage.m_callpy.m_user = Object();
        _this.storage.m_callpy.m_user.flash_state = m_callpy.m_user.flash_state;
        _this.storage.m_callpy.m_user.manager_request = m_callpy.m_user.manager_request;
        _this.storage.m_callpy.m_user.selected_manager = m_callpy.m_user.selected_manager;
        _this.storage.m_callpy.m_user.last_visit_time = m_callpy.m_user.last_visit_time;

        localStorage.setItem("callpy_data", JSON.stringify(_this.storage));

    };

    //записываем html-код
    //fromUser - указывает на то, что запись html в LocalStorage была вызвана именно действиями пользователя
    //это разграничивает случай, когда необходимо восстанавливать из LS. Если запись в LS была вызвана не пользователем (пришли какие-то данные в Realplexor),
    //то восстанавливать из LocalStorage вообще не требуется, поскольку данные приходят абсолютно во все вкладки
    this.saveHtml = function(fromUser)
    {
        if (m_callpy.client_data.type == 5) return;
        //TODO: может быть не активной ни одна вкладка, но при этом сохранить в LS необходимо
        //Пока просто сохраняем всегда (даже если вкладка не активна на вкладке со звонком)
        //if (($jcallpy("#callpy_main_container").length>0)){
            //TODO: FLAT: изменить получение HTML-кода
            //var html = $jcallpy('#callpy_wrapper').html();
            var html = document.querySelector('#callpy_wrapper').outerHTML;
            html = html.replace(' callpy_status_video', '');
            html = html.replace(' callpy_mobile_visible', '');

            var tmp = localStorage.getItem("callpy_html");
            if (html!=tmp){
                localStorage.setItem("callpy_html", fromUser?" "+html:html);
                //TODO: FLAT
                if (document.getElementById('callpy_chat_scroller')) localStorage.setItem("callpy_userId", document.getElementById('callpy_chat_scroller').scrollTop);
                //localStorage.setItem("callpy_text", document.getElementById('callpy_chat_input_box').value);
                //workaround for stupid IE8-11
                //!f - потому что в момент записи в LS чата при принятии входящего звонка вообще не требуется восстанавливать состояние, а в IE будет срабатывать onstorage для текущей вкладки
                if (_this.restoreInIE){
                    _this.handleFlag = false;
                    localStorage.setItem("html_save", new Date().getTime());
                }
            }

        //}
    };

    //TODO: данные необходимо восстанавливать ДО момента подписки на канал (иначе могут неверно обработаться)
    //восстанавливаем данные
    this.restoreData = function ()
    {
        _this.storage = JSON.parse(localStorage.getItem("callpy_data"));

        if (m_callpy.m_chat){
            if (_this.storage.m_callpy && _this.storage.m_callpy.m_chat && _this.storage.m_callpy.m_chat.history) m_callpy.m_chat.history = _this.storage.m_callpy.m_chat.history;
            if (_this.storage.m_callpy && _this.storage.m_callpy.m_chat && _this.storage.m_callpy.m_chat.history_dialogs) m_callpy.m_chat.history_dialogs = _this.storage.m_callpy.m_chat.history_dialogs;
            //else m_callpy.m_chat.history = [];
            //восстановить данные в $jcallpy('.callpy_mainContainer')
            /*if ($jcallpy('#callpy_main_container')){
                if (_this.storage.m_callpy.m_chat.mainContainer) $jcallpy('#callpy_main_container').data('status', _this.storage.m_callpy.m_chat.mainContainer.status);
            }*/
        }
    };

    //записываем данные для синхронизации между вкладками
    //fromUser - указывает на то, что данные изменены пользователем (нужно синхронизовать). Иначе - данные пришли от Realplexor и не нужно выполнять лишних действий - данные придут во все вкладки
    this.saveSyncData = function(fromUser)
    {
        if (_this.restoreInIE){
            _this.handleDataFlag = false;
        }
        localStorage.setItem("callpy_clientSyncData", (fromUser?" ":"") + JSON.stringify({department_id: m_callpy.client_data.department_id, clientInfo: m_callpy.client_data.clientInfo}));

    };

    //функция выше - для восстановления данных исключительно при инициализации в момент открытия новой вкладки
    //данный метод - для организации синхронизации важных данных между вкладками при их изменении на одной из вкладок. Использует тот же LS
    this.syncData = function ()
    {
        var tmp = localStorage.getItem("callpy_clientSyncData");
        if (tmp[0]!=" "){
            return;
        }else{
            tmp = tmp.substr(1);
        }
        tmp = JSON.parse(tmp);
        m_callpy.client_data.department_id = tmp.department_id;
        m_callpy.client_data.clientInfo = tmp.clientInfo;
        $jcallpy.callpy_departments('_set_select_department');
    }

};
